import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
/** A single teal scanline that sweeps across the section's top edge on scroll-into-view. */
export function Scanline() {
  const ref = useRef<HTMLDivElement>(null);
  const inView = useInView(ref, {
    once: true,
    margin: '-40px'
  });
  return <div ref={ref} aria-hidden="true" className="pointer-events-none absolute inset-x-0 top-0 h-px overflow-hidden" data-id="element-371">
      <motion.span initial={{
      x: '-100%'
    }} animate={inView ? {
      x: '100%'
    } : {}} transition={{
      duration: 2.5,
      ease: 'easeInOut'
    }} className="absolute inset-y-0 w-full bg-teal-600/35 will-change-transform" data-id="element-372" />
    </div>;
}